import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { ControlledTextField, AsyncSelect } from 'src/components/forms'
import { SectionBox } from 'src/pages/sistema/components/FieldView'
import { OperacionNOTESFields } from '../types/fields'
import CardActions from '../../../components/CardActions'
import { OpcionSiNo, useSiNoOptions } from '../../adcm/hooks/useOpcionesGenericas'

interface SeccionNOTESNuevoSeccionCuponProps {
  formMethods: UseFormReturn<any>
}

const SeccionNOTESNuevoSeccionCupon = ({ formMethods }: SeccionNOTESNuevoSeccionCuponProps) => {
  const { control, setValue, trigger } = formMethods
  const loadSiNo = useSiNoOptions()

  const watchedTieneCupon = useWatch({ control, name: OperacionNOTESFields.TieneCupon })

  useEffect(() => {
    if (watchedTieneCupon === OpcionSiNo.No) {
      setValue(OperacionNOTESFields.Cupon, '')
      setValue(OperacionNOTESFields.FrecuenciaPago, '')
      setValue(OperacionNOTESFields.CondicionPago, '')
      setValue(OperacionNOTESFields.ObsCupon, '')
    }
    if (watchedTieneCupon === OpcionSiNo.Si) {
      trigger([
        OperacionNOTESFields.Cupon,
        OperacionNOTESFields.FrecuenciaPago,
        OperacionNOTESFields.CondicionPago
      ])
    }
  }, [watchedTieneCupon, setValue, trigger])

  return (
    <CardActions title='Sección Cupón' icon='mdi:percent' colapsable>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label='¿Tiene cupón?'
            name={OperacionNOTESFields.TieneCupon}
            loadOptions={loadSiNo}
            control={control}
            fullWidth
            selectNotNulleable
          />
        </Grid>

        {watchedTieneCupon === OpcionSiNo.Si && (
          <>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Cupón' 
                name={OperacionNOTESFields.Cupon} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Frecuencia de pago' 
                name={OperacionNOTESFields.FrecuenciaPago} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Condición de pago' 
                name={OperacionNOTESFields.CondicionPago} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Observaciones adicionales' 
                name={OperacionNOTESFields.ObsCupon} 
                control={control} 
                fullWidth 
                multiline 
                rows={2} 
              />
            </Grid>
          </>
        )}
      </SectionBox>
    </CardActions>
  )
}

export default SeccionNOTESNuevoSeccionCupon